import { createRoot } from 'react-dom/client';
import { ClientApp } from './App';
import { BrowserRouter } from 'react-router';
import axios from 'axios';
import { applyTheme } from './utils/useTheme';

// Apply default theme immediately to prevent flash of unstyled content
applyTheme(null);

// Add axios interceptor to include x-tenant-id header
axios.interceptors.request.use((config) => {
  // You can get tenant ID from wherever you store it (localStorage, context, etc.)
  const tenantId = import.meta.env.VITE_TENANT_ID; // or however you store/get the tenant ID
  if (tenantId) {
    config.headers['x-tenant-id'] = tenantId;
  }
  return config;
});

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ClientApp />
  </BrowserRouter>
);
